import { render, staticRenderFns } from "./PatientIdentifierInput.vue?vue&type=template&id=28c12f51&scoped=true&"
import script from "./PatientIdentifierInput.vue?vue&type=script&lang=js&"
export * from "./PatientIdentifierInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientIdentifierInput.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PatientIdentifierInput.vue?vue&type=style&index=1&id=28c12f51&scoped=true&lang=css&"
import style2 from "./PatientIdentifierInput.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c12f51",
  null
  
)

export default component.exports